import React from 'react';
import cx from 'classnames';

import classes from './Table.module.scss';

interface IProps {
  className?: string;
  children: React.ReactNode;
}

const Cell: React.FC<IProps> = ({ className, children }) => (
  <td className={cx(classes.cell, className)}>{children}</td>
);

export default Cell;
